_ = require('underscore');
module.exports = {
    "tmplRecentHistoryItem": function(obj) {
var __t, __p = '';
__p += '\n    <li class="recent-history-item ' +
((__t = ( obj.additionalClasses )) == null ? '' : __t) +
'">\n        <a href="' +
((__t = ( obj.url )) == null ? '' : __t) +
'" title="' +
((__t = ( obj.title )) == null ? '' : __t) +
'" data-dealerpk="' +
((__t = ( obj.dealerPk )) == null ? '' : __t) +
'" class="recent-history-link">\n            <img src="' +
((__t = ( obj.imageUrl  )) == null ? '' : __t) +
'" title="' +
((__t = ( obj.title )) == null ? '' : __t) +
'" class="recent-history-item-img">\n        </a>\n    </li>\n';
return __p
}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/templates/global/recent-history.html
// module id = 811
// module chunks = 4 5 6 7 8